import { render, staticRenderFns } from "./bindtelphone.vue?vue&type=template&id=1675f86d&scoped=true&"
import script from "./bindtelphone.vue?vue&type=script&lang=js&"
export * from "./bindtelphone.vue?vue&type=script&lang=js&"
import style0 from "./bindtelphone.vue?vue&type=style&index=0&id=1675f86d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675f86d",
  null
  
)

export default component.exports